import { useEffect, useState } from 'react';
import { LockStatusResult } from '../types/models';

// Owns the two "something went wrong" modals so App only has to render them.
export const useErrorModals = (isAuthError: boolean, lockStatus: LockStatusResult) => {
    const [isAuthErrorModalOpen, setIsAuthErrorModalOpen] = useState(false);
    const [isUnlockFailedModalOpen, setIsUnlockFailedModalOpen] = useState(false);

    useEffect(() => {
        if (isAuthError === true) {
            setIsAuthErrorModalOpen(true);
        }
    }, [isAuthError]);

    useEffect(() => {
        if (lockStatus === LockStatusResult.Error) {
            setIsUnlockFailedModalOpen(true);
        }
    }, [lockStatus]);

    return {
        isAuthErrorModalOpen,
        closeAuthErrorModal: () => setIsAuthErrorModalOpen(false),
        isUnlockFailedModalOpen,
        closeUnlockFailedModal: () => setIsUnlockFailedModalOpen(false),
    };
};
